import './POIHeader.css';
import React, { useState } from 'react';
import { get, getDictionaryItem, getGlobalDictionaryTerm } from '../../utils';
import StickyCtaAssistant from '../../utils/StickyCtaAssistant';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import FavouriteBtn from '../atoms/FavouriteBtn/FavouriteBtn';
import closeWhite from '../../resources/icons/close-white.svg';
import chevronRight from '../../resources/icons/chevron-right.svg';
import arrowLeftNoborderWhite from '../../resources/icons/arrow-left-noborder-white.svg';
import arrowRightNoborderWhite from '../../resources/icons/arrow-right-noborder-white.svg';
import { Text, RichText, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import LazyPicture from '../atoms/LazyPicture';
import Video from '../atoms/Video';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import TripAdvisor from '../atoms/TripAdvisor/TripAdvisor';
import { fullWidthStyles } from '../57_HeaderFullWidth/headerFullWidth';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
export const POIHeader = _ref => {
  let {
    fields,
    rendering,
    children,
    params
  } = _ref;
  const [activeHpol, setActiveHpol] = useState('');
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const isSharedCh = get(params, 'RenderingStyle') === 'Shared Channels' || false;
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const addToFavAnalytics = get(fields || {}, 'data.addToFavAnalytics');
  const bookNowAnalytics = get(fields || {}, 'data.bookNowAnalytics');
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing); // eslint-disable-line
  const newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || 'Opens in a new window';
  const hasCategory = Boolean(get(fields, 'data.item.category.targetItem.title.jss.value'));
  const category = get(fields, 'data.item.category.targetItem.title.jss');
  const introText = get(fields, 'data.item.introText.jss');
  const hasIntroText = Boolean(get(fields, 'data.item.introText.jss'));
  const title = get(fields, 'data.item.title.jss');
  const hasTitle = get(fields, 'data.item.title.jss.value');
  const curatorString = get(fields, 'data.item.curators.jss.value');
  const curators = Boolean(curatorString) && JSON.parse(curatorString).curators;
  const dictionaryValues = get(fields, 'data.dictionary');
  const curatorsPhrase = getDictionaryItem(dictionaryValues, 'CuratorsRecommend');
  const curatorsPick = getDictionaryItem(dictionaryValues, 'CuratorsPick') || `CURATOR'S PICKS`;
  const tripAdvisorRatingImg = get(fields, 'data.item.tripAdvisorRatingImageUrl.jss.value');
  const tripAdvisorScore = get(fields, 'data.item.tripAdvisorRating.jss.value');
  const moduleId = get(fields, 'data.item.id');
  const moduleName = get(fields, 'data.item.name');
  const {
    recommendationClickAnalytics
  } = fields.data;
  const mainTripadvisorReviews = get(fields, 'data.item.tripAdvisorNumberReviews.jss.value');
  const mainTripadvisorPrice = get(fields, 'data.item.tripAdvisorPriceLevel.jss.value');
  const buyLinkWebsite = get(fields, 'data.item.buyLinkWebsite.jss.value.href');
  const bookingButton = getDictionaryItem(dictionaryValues, 'BookTickets') || '';
  const backButton = getDictionaryItem(dictionaryValues, 'BackButton') || 'backButton';
  const renderMediaPlaceholder = () => {
    return /*#__PURE__*/React.createElement(Placeholder, {
      name: "media-header-general",
      rendering: rendering,
      mediaDesc: introText ? introText.value : ''
    });
  };
  const renderCurators = () => {
    if (!curators || curators.length === 0) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "curators__block"
    }, /*#__PURE__*/React.createElement("div", {
      className: "curators__row",
      onClick: e => showCurators(e),
      onKeyPress: e => {
        if (e.which === 13 || e.which === 32) {
          e.preventDefault();
          showCurators(e);
        }
      },
      tabIndex: 0
    }, Array.from(curators) && Array.from(curators).map((curator, index) => {
      return /*#__PURE__*/React.createElement("span", {
        className: "curators__item-link",
        key: index
      }, /*#__PURE__*/React.createElement(LazyPicture, null, /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 768px)",
        srcSet: curator.Image + '&cw=24&ch=24'
      }), /*#__PURE__*/React.createElement("img", {
        className: "curators__image-item",
        src: curator.Image + '&cw=24&ch=24',
        alt: curator.Name
      })));
    })), /*#__PURE__*/React.createElement("div", {
      className: "curators__author"
    }, curatorsPick));
  };
  const showCurators = e => {
    e.preventDefault();
    setActiveHpol('show-hpol');
  };
  const closeCurators = e => {
    e.preventDefault();
    setActiveHpol('');
  };
  const renderRecommendedCurators = nb => {
    if (!curators) {
      return null;
    }
    return curators && curators.map((item, index) => {
      return /*#__PURE__*/React.createElement("a", {
        className: "h-curators__listing-item",
        href: item.Url,
        key: index,
        onClick: () => {
          tealiumClickFunc(tealiumMergeClickData(recommendationClickAnalytics, params), item.Name);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "h-curators__listing-img-wrap"
      }, /*#__PURE__*/React.createElement(LazyPicture, null, /*#__PURE__*/React.createElement("source", {
        media: "(min-width: 768px)",
        srcSet: item.Image + '&cw=40&ch=40'
      }), /*#__PURE__*/React.createElement("img", {
        className: "h-curators__listing-img",
        src: item.Image + '&cw=40&ch=40',
        alt: item.Name
      }))), /*#__PURE__*/React.createElement("div", {
        className: "h-curators__text"
      }, item.Name ? /*#__PURE__*/React.createElement("h2", {
        className: "h-curators__listing-name"
      }, item.Name) : '', item.Role ? /*#__PURE__*/React.createElement("div", {
        className: "h-curators__listing-type"
      }, item.Role) : ''), /*#__PURE__*/React.createElement("img", {
        className: "h-curators__listing-icon",
        src: chevronRight,
        alt: item.Name
      }));
    });
  };
  const handleBookAnalytic = e => {
    tealiumClickFunc(tealiumMergeClickData(bookNowAnalytics, params), `${moduleName}`);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter'],
    isSharedCh: isSharedCh
  }, buyLinkWebsite ? /*#__PURE__*/React.createElement(StickyCtaAssistant, null) : '', /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header__poi"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ha__img"
  }, /*#__PURE__*/React.createElement("div", {
    className: `header-bb__wrapper header-bb__wrapper--poster-show ${isSharedCh ? 'fav-btn-box--shared' : ''}`
  }, process.env.STORYBOOK_MODE ? children : renderMediaPlaceholder(), /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: moduleId,
    classes: 'fav-btn fav-btn-mobile',
    analyticsClick: action => tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, params), `${action} : ${moduleName}`)
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alignment-with-richtext-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: `${activeHpol ? 'col-lg-9 col-md-9 col-sm-10 col-xs-10' : ''} `
  }, /*#__PURE__*/React.createElement("div", {
    className: `poi__header-info ${activeHpol}`
  }, curators && curators.length ? /*#__PURE__*/React.createElement("div", {
    className: "header-bb__curators"
  }, renderCurators()) : /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement("div", {
    className: "ha__desc--desk"
  }, /*#__PURE__*/React.createElement("div", {
    className: "head-content"
  }, /*#__PURE__*/React.createElement("p", {
    className: "body-medium uppercase ha__localization-x"
  }, hasCategory && /*#__PURE__*/React.createElement(Text, {
    field: category
  })), /*#__PURE__*/React.createElement("div", {
    className: "head-content__top"
  }, hasTitle && /*#__PURE__*/React.createElement(Text, {
    className: "h1 h__title",
    tag: "h1",
    field: title
  }), /*#__PURE__*/React.createElement("div", {
    className: "header__actions",
    id: "poi-header-action"
  }, buyLinkWebsite && bookingButton && /*#__PURE__*/React.createElement("a", {
    href: buyLinkWebsite,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "btn btn-primary header__book-tickets",
    "aria-label": `${bookingButton} | ${newWindowLabel}`,
    onClick: e => handleBookAnalytic(e)
  }, bookingButton), /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: moduleId,
    classes: 'fav-btn fav-btn-desktop',
    analyticsClick: action => tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, params), `${action} : ${moduleName}`)
  })))), hasIntroText && /*#__PURE__*/React.createElement(RichText, {
    className: "body-large",
    field: introText
  }), tripAdvisorRatingImg && /*#__PURE__*/React.createElement("div", {
    className: "header__push-bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header__trip-advisor"
  }, /*#__PURE__*/React.createElement(TripAdvisor, {
    imageRatingSRC: tripAdvisorRatingImg,
    score: tripAdvisorScore,
    alt: "Tripadvisor",
    tripadvisorReviews: mainTripadvisorReviews,
    tripadvisorPrice: mainTripadvisorPrice,
    reviewCaption: getDictionaryItem(dictionaryValues, 'reviews')
  })), /*#__PURE__*/React.createElement("div", {
    className: "favourite-btn-curators"
  }, /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: moduleId,
    classes: 'fav-btn1 fav-btn-desktop1',
    analyticsClick: action => tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, params), `${action} : ${moduleName}`)
  })))))))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: `row book-button ${activeHpol}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-2 col-md-2 col-sm-1 col-xs-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-9 col-md-9 col-sm-10 col-xs-10"
  }, buyLinkWebsite && bookingButton && /*#__PURE__*/React.createElement("a", {
    href: buyLinkWebsite,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "btn btn-primary header__book-tickets",
    "aria-label": `${bookingButton} | ${newWindowLabel}`,
    onClick: e => handleBookAnalytic(e)
  }, bookingButton)), /*#__PURE__*/React.createElement("div", {
    className: "col-lg-1 col-md-1 col-sm-1 col-xs-1"
  })), /*#__PURE__*/React.createElement("div", {
    className: `hpol ${activeHpol}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "hpol__height"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hpol__header"
  }, /*#__PURE__*/React.createElement("span", {
    tabIndex: 0,
    className: "hpol__close-btn d-none d-md-block",
    onClick: e => closeCurators(e),
    onKeyPress: e => {
      if (e.which === 13 || e.which === 32) {
        e.preventDefault();
        closeCurators(e);
      }
    }
  }, /*#__PURE__*/React.createElement("img", {
    className: "hpol__close-btn-img",
    src: closeWhite,
    alt: "close"
  })), /*#__PURE__*/React.createElement("span", {
    onClick: e => closeCurators(e),
    className: "hpol__back-btn d-block d-md-none"
  }, /*#__PURE__*/React.createElement("img", {
    className: "hpol__back-btn-img",
    src: rtl ? arrowRightNoborderWhite : arrowLeftNoborderWhite,
    alt: "back"
  }), /*#__PURE__*/React.createElement("span", null, backButton)), /*#__PURE__*/React.createElement(Text, {
    className: "hpol__title h2",
    tag: "h3",
    field: {
      value: curatorsPhrase
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "hpol__scroller"
  }, /*#__PURE__*/React.createElement("div", {
    className: "h-curators__listing"
  }, renderRecommendedCurators(15))))))))))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter,
    isSharedCh
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `remove-padding-bottom-mob   ${isSharedCh ? "c1y6yjoe" : ''} ${headerCommonStyle} ${fullWidthStyles} ${rtl ? rtlStyles : ltrStyles} ${headerStyle} ${headerImageStyle} ${headerPoiStyle}`
  }, children);
};
const headerCommonStyle = "h1hmxtj3";
const headerStyle = "h167c3m4";
const headerPoiStyle = "he5hyuo";
const ltrStyles = "l168d7j7";
const rtlStyles = "rf7xvjp";
export default POIHeader;